import React, { useCallback, useEffect, useState } from 'react';

import { token } from '@atlaskit/tokens';

import integration from 'src/lib/api/integration';
import { textifyError } from 'src/lib/error';

const CredentialsValidation = ({ validator }) => {
  const [status, setStatus] = useState('validating');
  const [message, setMessage] = useState('validating...');

  useEffect(() => {
    let mounted = true;
    validator().then(res => {
      const status = res.validation_status;
      let message = res.message;
      if (!message && status === 'ok') message = 'Credentials are valid';
      if (!message && status !== 'ok') message = 'Credentials are not valid';
      if (!mounted) return;
      setStatus(status);
      setMessage(message);
    })
      .catch(error => {
        if (!mounted) return;
        setStatus('error');
        setMessage(textifyError(['Failed to check credentials:', error]));
      });
    return () => { mounted = false; };
  }, [validator]);

  let color = token('color.text.danger', 'red');
  if (status === 'validating') color = token('color.text.subtle', 'gray');
  if (status === 'ok') color = token('color.text.success', 'green');

  return (
    <div style={{ display: 'flex', flexFlow: 'row-reverse' }}>
      <span style={{ color }}>{message}</span>
    </div>
  );
};

export const PagerDutyCredentialsValidation = () => {
  const validator = useCallback(() => integration.validatePagerDutyCredentials(), []);
  return <CredentialsValidation validator={validator}/>;
};

export const JiraCredentialsValidation = () => {
  const validator = useCallback(() => integration.validateJiraCredentials(), []);
  return <CredentialsValidation validator={validator}/>;
};
